import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ViewNames } from "../../types";

interface CreateFormState {
  isOpen: boolean;
  mode: "create" | "edit" | null;
  initialValues?: Record<string, unknown> | null;
  dialogView?: ViewNames;
}

const initialState: CreateFormState = {
  isOpen: false,
  mode: null,
  initialValues: null,
};

export const createFormSlice = createSlice({
  name: "createForm",
  initialState,
  reducers: {
    openForm(
      state,
      action: PayloadAction<{
        mode: "create" | "edit";
        initialValues?: Record<string, unknown>;
        dialogView?: ViewNames;
      }>,
    ) {
      state.isOpen = true;
      state.mode = action.payload.mode;
      state.initialValues = action.payload.initialValues || null;
      state.dialogView = action.payload.dialogView;
    },
    closeForm(state) {
      state.isOpen = false;
      state.mode = null;
      state.initialValues = null;
    },
  },
});
